import {
  getModuleCache,
  getScreenData,
  removeScreenData,
} from 'cw-ui-core';
import { legacy_connect as connect } from 'react-redux';
import { ASIO_ENABLEMENT_DIALOG_ID } from './AsioEnablementDialogContainer';
import BrightGaugeConfirmationStep from './BrightGaugeConfirmationStep';

const mapStateToProps = state => {
  const partnerRegion = getModuleCache(state.module, ['partner', 'region']);
  const region = partnerRegion === 'North America' ? 'America' : partnerRegion;
  const brightGaugeValidationErrors = getScreenData(state.screen, ['brightGaugeValidationErrors'])?.toJS();
  const partnerCompany = getModuleCache(state.module, ['partner', 'companyName']) || '';
  const subDomainName = partnerCompany.replace(/[^a-zA-Z0-9-]/g, '');

  return {
    partnerCompany,
    subDomainName,
    region,
    brightGaugeValidationErrors,
    asioMemberCode: getScreenData(
      state.screen,
      ['memberCode'],
      ASIO_ENABLEMENT_DIALOG_ID
    ),
    country: getModuleCache(state.module, ['partner', 'country'])
  };
};

const mapDispatchToProps = dispatch => ({
  onClosedIconClick: () => {
    dispatch(removeScreenData('brightGaugeValidationErrors'));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(BrightGaugeConfirmationStep);
